<template>
  <section-page
    title="Task Tags"
    description="Tags allow you to organize your tasks however you like."
  >
    <template v-slot:right>
      <button-outlined icon-left="plus" @click="add">
        New Tag
      </button-outlined>
    </template>

    <app-empty-message
      :count="taskTags.length"
      heading="You don't have any tags. Why don't you make one."
    >
      <table-default
        :table-data="taskTags"
        default-sort="label"
      >
        <b-table-column label="Label" field="label" sortable v-slot="props">
          {{ props.row.label }}
        </b-table-column>

        <b-table-column label="Default" field="default" centered sortable width="120" v-slot="props">
          <icon-default
            icon="check"
            size="is-small"
            color="is-success"
            v-if="props.row.default"
          />
        </b-table-column>

        <b-table-column cell-class="action_cell" width="120" v-slot="props">
          <button-link @click="edit(props.row)">Manage</button-link>
        </b-table-column>
      </table-default>
    </app-empty-message>

    <modal-container>
      <modal-crud-form
        ref="tagTaskModal"
        title="Task Tag"
        form-component="tag-task-form">
      </modal-crud-form>
    </modal-container>
  </section-page>
</template>

<script>
export default {
  name: "TaskTags",
  computed: {
    taskTags() {
      return this.$store.getters.taskTags;
    },
  },
  methods: {
    add() {
      this.$refs.tagTaskModal.open();
    },
    edit(tag) {
      this.$refs.tagTaskModal.open(tag);
    },
  }
}
</script>

<style scoped lang="scss">

</style>
